var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M.1.9h2.4v14.9H.1zM4.4 9.6c1.2-.7 2.6-.9 4-.6 1.1.3 2.3 2.5 3.5 2.5 3.8 0 3.9-1 3.9-1V1.9s-.2 1-3.9 1C10.7 2.9 9.4.7 8.4.4 7 .1 5.6.2 4.4.9v8.7z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Flagged.svg